import styled from 'styled-components';
import TransparentButton from '../../button/TransparentButton';
var CategoryLink = styled(TransparentButton).attrs({
  $size: 'small'
}).withConfig({
  displayName: "CategoryLink",
  componentId: "sc-1xu8qva-0"
})(["overflow:hidden;text-overflow:ellipsis;"]);
export default CategoryLink;